import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import { OutlinedInput } from "@mui/material";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/es";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Restricted from "components/Restricted";
import Autocomplete from "@mui/material/Autocomplete";
import { IMaskInput } from "react-imask";
import FormHelperText from "@mui/material/FormHelperText";

import clienteAxios from "../../config/clienteAxios";
import axios from "axios";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{ p: 1, m: 1, fontSize: "0.875rem", fontWeight: "700", ...sx }}
      {...other}
    />
  );
}

Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+00(#00) 000-0000"
      definitions={{ "#": /[0-9]/ }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const NutriSaludForm = () => {
  const clienteAxiosRef = useRef(null);
  const getAxiosClient = async () => {
    if (clienteAxiosRef.current) {
      return clienteAxiosRef.current;
    }
    const module = await import("../../config/clienteAxios");
    clienteAxiosRef.current = module.default;
    return module.default;
  };

  const proyect = {
    actividad: ["Jornada de Nutrición", "Jornada Médica"],
    fecha: new Date(),
    estadoConvo: "1",
    municipio: "1",
    parroquia: "1",
    comunidad: "Centro de Salud de Prueba",
    idProyecto: 1,
    id: 101,
  };

  let tipoActividad = 0;
  const tipoAct = proyect.actividad;
  const valoresActividad = {
    "Jornada de Nutrición": 1,
    "Control Nutricional": 1,
    "Jornada Médica": 2,
    Telemedicina: 3,
  };
  const [clasificacion, setClasificacion] = React.useState("");
  if (tipoAct.includes("Telemedicina") && tipoAct.includes("Jornada Médica")) {
    tipoActividad = 3;
  } else if (
    tipoAct.includes("Jornada de Nutrición") &&
    tipoAct.includes("Jornada Médica")
  ) {
    tipoActividad = 0;
  } else {
    for (const actividad of tipoAct) {
      tipoActividad += valoresActividad[actividad] || 0;
    }
  }

  const nav = useNavigate();
  const [items, setItems] = React.useState({});

  useEffect(() => {
    const storedItems = { usuario: "testuser", rol: "1" };
    if (tipoActividad === 3) {
      setClasificacion("Telemedicina");
    }
    if (storedItems) {
      setItems(storedItems);
    }
  }, [tipoActividad]);

  const rol = items.rol || "1";
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //Modal Styles
  const style = {
    position: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 375,
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 1,
    p: 4,
  };

  const [errors, setErrors] = useState({});
  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
    }
  };

  const [fechaNacSalud, setFechaNacSalud] = React.useState(null);
  const [fechaActSalud, setFechaActSalud] = React.useState(proyect.fecha);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [data, setData] = useState([{ motivoConsulta: "" }]);
  const [activar, setActivar] = useState(true);
  const [data3, setData3] = useState([{ diagnostico: "" }]);
  const [activar3, setActivar3] = useState(true);
  const oracionFormato = (str) =>
    typeof str === "string"
      ? str
          .toLowerCase()
          .split(" ")
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(" ")
      : "";
  const [estadoSalud, setEstadoSalud] = useState(proyect.estadoConvo);
  const [municipioSalud, setMunicipioSalud] = useState(proyect.municipio);
  const [parroquiaSalud, setParroquiaSalud] = useState(proyect.parroquia);
  const [comunidadSalud, setComunidadSalud] = useState("");
  const [estSalud, setEstSalud] = useState(proyect.comunidad);
  const [valueCedula, setValueCedula] = useState("");
  const [tlf, setValueTlf] = useState({ textmask: "" });
  const [peso, setPeso] = useState("");
  const [valueRep, setValueRep] = useState("");
  const [valueApellidoRep, setValueApellidoRep] = useState("");
  const [valueNombre, setValueNombre] = useState("");
  const [codigoBeneficiario, setCodigoBeneficiario] = useState("");
  const [valueApellido, setValueApellido] = useState("");
  const [edadSalud, setEdadSalud] = useState("");
  const [edadEnMeses, setEdadEnMeses] = useState(null);
  const [rangoEdadSalud, setRangoEdadSalud] = useState("");
  const [tipoEnfermedad, setTipoEnfermedad] = useState("");
  const [tipoEnfermedad2, setTipoEnfermedad2] = useState("");
  const [comentAdicionales, setValueCA] = useState("");
  const [condicionMujer, setCondicionMujer] = useState("");
  const [semanasGestacion, setSemanasGestacion] = useState("");
  const [codigoGrupoEtnico, setCodigoGrupoEtnico] = useState("");
  const [grupoEtnico, setGrupoEtnico] = useState("");
  const [codigoDisc, setCodigoDisc] = useState("");
  const [valueDisc, setDisc] = useState("");
  const [codigoMovilidad, setCodigoMovilidad] = useState("");
  const [condicionMovilidad, setCondicionMovilidad] = useState("");
  const [codigoFactoresRiesgo, setCodigoFactoresRiesgo] = useState("");
  const [factoresRiesgo, setFactoresRiesgo] = useState("");
  const [codigoFactoresRiesgo2, setCodigoFactoresRiesgo2] = useState("");
  const [factoresRiesgo2, setFactoresRiesgo2] = useState("");
  const [codigoFactoresRiesgo3, setCodigoFactoresRiesgo3] = useState("");
  const [factoresRiesgo3, setFactoresRiesgo3] = useState("");
  const [codigoNivelEducativo, setCodigoNivelEducativo] = useState("");
  const [nivelEducativo, setNivelEducativo] = useState("");
  const [codigoTipoEnf, setCodigoTipoEnf] = useState("");
  const [codigoTipoEnf2, setCodigoTipoEnf2] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [medicamentos, setMedicamentos] = useState([]);
  const [patologias, setPatologias] = useState([]);
  const [tratamiento, setTratamiento] = useState([]);
  const [inputTratamiento, setInputTratamiento] = useState([]);
  const [medicoM5, setMedicoM5] = useState("");
  const [ejecutar, setEjecutar] = useState(true);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [disableBtnSalud, setDisableBtnSalud] = useState(false);
  const [valueGenero, setValueGenero] = useState("");
  const [sexoBenef, setSexoBenef] = useState("");
  const [lgbtqi, setLgbtqi] = useState("");
  const [cabezaFamilia, setCabezaFamilia] = useState("");
  const [ingresosPropios, setIngresosPropios] = useState("");
  const [edema, setEdema] = useState("No");
  const [cmbM5, setCmbM5] = useState("");
  const [pbM5, setPbM5] = useState("");
  const [pesoM5, setPesoM5] = useState("");
  const [tallaM5, setTallaM5] = useState("");
  const [puntajezM5, setPuntajeZM5] = useState("");
  const [clasificacionNutM5, setClasificacionNutM5] = useState("");
  const [pzTallaEdadM5, setPzTallaEdadM5] = useState("");
  const [clasificacionTallaEdadM5, setClasificacionTallaEdadM5] = useState("");
  const [diagFinalM5, setDiagFinalM5] = useState("");
  const [consejM5, setConsejM5] = useState("No");
  const [referidoM5, setReferidoM5] = useState("No");
  const [albendazolM5, setAlbendazolM5] = useState("No");
  const [micronutM5, setMicronutM5] = useState("No");
  const [lnsmq, setLnsmq] = useState("No");
  const [rutfM5, setRutfM5] = useState("No");
  const [amoxM5, setAmoxM5] = useState("No");
  const [kitHigieneM5, setKitHigieneM5] = useState("No");
  const [kitRepoM5, setKitRepoM5] = useState("No");
  const [albendazolDosisM5, setAlbendazolDosisM5] = useState("");
  const [dosisMedicamentoM5, setDosisMedicamentoM5] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [openNotiError, setOpenNotiError] = useState(false);
  const [pesoGL, setPesoGL] = useState("");
  const [tallaGL, setTallaGL] = useState("");
  const [imcGL, setImcGL] = useState("");
  const [diagIngresoGL, setDiagIngresoGL] = useState("");
  const [tiempoLactancia, setTiempoLactancia] = useState("");
  const [pbGL, setPbGL] = useState("");
  const [dosisCalcio, setDosisCalcio] = useState("N/A");
  const [dosisAcidoFolico, setDosisAcidoFolico] = useState("N/A");
  const [dosisSulfatoFerroso, setDosisSulfatoFerroso] = useState("N/A");
  const [dosisPlumpyMum, setDosisPlumpyMum] = useState("N/A");
  const [diagNutM5, setDiagNutM5] = useState(0);
  const [diagPbM5, setDiagPbM5] = useState(0);

  const handleClick = () => {
    if (data.length < 5) {
      setData([...data, { motivoConsulta: "" }]);
      setActivar(true);
    }
  };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...data];
    onchangeVal[i][name] = value;
    setData(onchangeVal);
    clearError("motivoConsulta");
    setActivar(onchangeVal.some((item) => item.motivoConsulta.trim() === ""));
  };
  const handleDelete = (i) => {
    const deleteVal = [...data];
    deleteVal.splice(i, 1);
    setData(deleteVal);
    setActivar(deleteVal.some((item) => item.motivoConsulta.trim() === ""));
  };
  const handleClick3 = () => {
    if (data3.length < 5) {
      setData3([...data3, { diagnostico: "" }]);
      setActivar3(true);
    }
  };
  const handleChangeInput3 = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal3 = [...data3];
    onchangeVal3[i][name] = value;
    setData3(onchangeVal3);
    clearError("diagnostico");
    setActivar3(onchangeVal3.some((item) => item.diagnostico.trim() === ""));
  };
  const handleDelete3 = (i) => {
    const deleteVal3 = [...data3];
    deleteVal3.splice(i, 1);
    setData3(deleteVal3);
    setActivar3(deleteVal3.some((item) => item.diagnostico.trim() === ""));
  };
  const handleLinkCancelar = () => nav(-1);
  const handleLinkHome = () => nav("/inicio");
  const handleLinkTranscripcion = () => nav(-1);
  const handleTlf = (e) =>
    setValueTlf({ ...tlf, [e.target.name]: e.target.value });
  const handleCodigoGrupoEtnico = (e) => {
    const v = e.target.value;
    clearError("codigoGrupoEtnico");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 7))
      setCodigoGrupoEtnico(v);
  };
  const handleCodigoDisc = (e) => {
    const v = e.target.value;
    clearError("codigoDisc");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 5))
      setCodigoDisc(v);
  };
  const handleCodigoMovilidad = (e) => {
    const v = e.target.value;
    clearError("codigoMovilidad");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 5))
      setCodigoMovilidad(v);
  };
  const handleCodigoFactoresRiesgo = (e) => {
    const v = e.target.value;
    clearError("codigoFactoresRiesgo");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 12))
      setCodigoFactoresRiesgo(v);
  };
  const handleCodigoFactoresRiesgo2 = (e) => {
    const v = e.target.value;
    clearError("codigoFactoresRiesgo2");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 12))
      setCodigoFactoresRiesgo2(v);
  };
  const handleCodigoFactoresRiesgo3 = (e) => {
    const v = e.target.value;
    clearError("codigoFactoresRiesgo3");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 12))
      setCodigoFactoresRiesgo3(v);
  };
  const handleCodigoNivelEducativo = (e) => {
    const v = e.target.value;
    clearError("codigoNivelEducativo");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 6))
      setCodigoNivelEducativo(v);
  };
  const handleCodigoTipoEnf = (e) => {
    const v = e.target.value;
    clearError("codigoTipoEnf");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 26))
      setCodigoTipoEnf(v);
  };
  const handleCodigoTipoEnf2 = (e) => {
    clearError("codigoTipoEnf2");
    setCodigoTipoEnf2(e.target.value);
  };
  const handleChangeGenero = (e) => {
    clearError("valueGenero");
    setValueGenero(e.target.value);
  };
  const handleSexoBenef = (e) => {
    const newSexo = e.target.value;
    clearError("sexoBenef");
    setSexoBenef(newSexo);
    if (newSexo !== "Mujer") {
      setCondicionMujer("");
      setSemanasGestacion("");
      setTiempoLactancia("");
    }
  };
  const handleCondicionMujer = (e) => {
    const newCondicion = e.target.value;
    setCondicionMujer(newCondicion);
    if (newCondicion !== "En Gestación") setSemanasGestacion("");
    if (newCondicion !== "En Lactancia") setTiempoLactancia("");
  };
  const handleSemanasGestacion = (e) => setSemanasGestacion(e.target.value);
  const semanasGestacionOptions = Array.from(
    { length: 42 },
    (_, i) => `${i + 1} Semana${i > 0 ? "s" : ""}`,
  );
  const handleTiempoLactancia = (e) => {
    const val = e.target.value;
    if (/^\d{0,2}$/.test(val)) setTiempoLactancia(val);
  };
  const handleLgbtqi = (e) => {
    clearError("lgbtqi");
    setLgbtqi(e.target.value);
  };
  const handleCabezaFamilia = (e) => {
    clearError("cabezaFamilia");
    setCabezaFamilia(e.target.value);
  };
  const handleIngresosPropios = (e) => {
    clearError("ingresosPropios");
    setIngresosPropios(e.target.value);
  };
  const handleChangeEdema = (e) => setEdema(e.target.value);
  const handleCmbM5 = (event) => {
    const cmbValue = event.target.value;
    setCmbM5(cmbValue);
    const cmbNum = Number(cmbValue);
    if (edadEnMeses >= 6 && edadEnMeses <= 59 && cmbNum > 0) {
      if (cmbNum < 11.5) {
        setPbM5("Desnutrición Aguda Severa");
        setDiagPbM5(1);
      } else if (cmbNum >= 11.5 && cmbNum <= 12.4) {
        setPbM5("Desnutrición Aguda Moderada");
        setDiagPbM5(2);
      } else if (cmbNum >= 12.5) {
        setPbM5("Adecuado");
        setDiagPbM5(5);
      }
    } else {
      setPbM5("");
      setDiagPbM5(0);
    }
  };
  const handlePuntajeZ = (event) => {
    setPuntajeZM5(event.target.value.replace(/[d]/g, "").slice(0, 6));
    if (
      Number(event.target.value) <= -3 &&
      Number(event.target.value) >= -5 &&
      edema !== "Si"
    ) {
      setClasificacionNutM5("Desnutrición Aguda Severa");
      setDiagNutM5(1);
    } else {
      if (
        Number(event.target.value) <= -2 &&
        Number(event.target.value) >= -2.99 &&
        edema !== "Si"
      ) {
        setClasificacionNutM5("Desnutrición Aguda Moderada");
        setDiagNutM5(2);
      } else {
        if (
          Number(event.target.value) <= 1.99 &&
          Number(event.target.value) >= -1.99 &&
          event.target.value !== "" &&
          edema !== "Si"
        ) {
          setClasificacionNutM5("Adecuado");
          setDiagNutM5(5);
        } else {
          if (
            Number(event.target.value) >= 2 &&
            Number(event.target.value) <= 2.99 &&
            edema !== "Si"
          ) {
            setClasificacionNutM5("Sobrepeso");
            setDiagNutM5(3);
          } else {
            if (Number(event.target.value) >= 3 && edema !== "Si") {
              setClasificacionNutM5("Obesidad");
              setDiagNutM5(4);
            } else {
              if (event.target.value === "" && edema !== "Si") {
                setClasificacionNutM5("");
                setDiagNutM5(0);
              }
            }
          }
        }
      }
    }
  };

  const handleChangeConsejM5 = (e) => setConsejM5(e.target.value);
  const handleReferidoM5 = (e) => setReferidoM5(e.target.value);
  const handleChangeAlbendazolM5 = (e) => setAlbendazolM5(e.target.value);
  const handleChangeMicronutM5 = (e) => setMicronutM5(e.target.value);
  const handleChangeLnsmq = (e) => setLnsmq(e.target.value);
  const handleChangeRutfM5 = (e) => setRutfM5(e.target.value);
  const handleChangeAmoxM5 = (e) => setAmoxM5(e.target.value);
  const handleKitHigieneM5 = (e) => setKitHigieneM5(e.target.value);
  const handleKitRepoM5 = (e) => setKitRepoM5(e.target.value);
  const handleAlbendazolDosisM5 = (e) => setAlbendazolDosisM5(e.target.value);
  const handlePbGL = (e) => {
    const v = e.target.value;
    if (/^\d*\.?\d*$/.test(v)) setPbGL(v);
  };

  useEffect(() => {
    const map = {
      1: "Mestizo",
      2: "Wayuu",
      3: "Añu",
      4: "Japreria",
      5: "Yanomami",
      6: "Bari",
      7: "Yukpa",
    };
    setGrupoEtnico(
      map[codigoGrupoEtnico] || (codigoGrupoEtnico ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoGrupoEtnico]);
  useEffect(() => {
    const map = {
      1: "Física",
      2: "Intelectual",
      3: "Sensorial",
      4: "Múltiple",
      5: "Ninguna",
    };
    setDisc(map[codigoDisc] || (codigoDisc ? "VERIFICAR CÓDIGO" : ""));
  }, [codigoDisc]);
  useEffect(() => {
    const map = {
      1: "Local",
      2: "Desplazado Interno",
      3: "Refugiado",
      4: "Retornado",
      5: "Pendular",
    };
    setCondicionMovilidad(
      map[codigoMovilidad] || (codigoMovilidad ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoMovilidad]);
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    setFactoresRiesgo(
      map[codigoFactoresRiesgo] ||
        (codigoFactoresRiesgo ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoFactoresRiesgo]);
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    setFactoresRiesgo2(
      map[codigoFactoresRiesgo2] ||
        (codigoFactoresRiesgo2 ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoFactoresRiesgo2]);
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    setFactoresRiesgo3(
      map[codigoFactoresRiesgo3] ||
        (codigoFactoresRiesgo3 ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoFactoresRiesgo3]);
  useEffect(() => {
    const map = {
      1: "Prescolar",
      2: "Primaria",
      3: "Secundaria",
      4: "Universitario",
      5: "Sin estudios",
      6: "Analfabeta",
    };
    setNivelEducativo(
      map[codigoNivelEducativo] ||
        (codigoNivelEducativo ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoNivelEducativo]);
  const tipoEnfermedadMap = {
    1: "Adulto sano",
    2: "Algunas enfermedades infecciosas o parasitarias",
    3: "Anomalías del desarrollo prenatal",
    4: "Condiciones relacionadas con la salud sexual",
    5: "Embarazo, parto, puerperio o trastornos hormonales",
    6: "Enfermedades de la piel y anexos",
    7: "Enfermedades de la sangre o de los órganos hematopoyéticos",
    8: "Enfermedades de las glándulas mamarias",
    9: "Enfermedades degenerativas",
    10: "Enfermedades del aparato digestivo",
    11: "Enfermedades del aparato genitourinario",
    12: "Enfermedades del aparato respiratorio",
    13: "Enfermedades del ojo y sus anexos",
    14: "Enfermedades del oído o de la apófisis mastoides",
    15: "Enfermedades del sistema circulatorio o cardiovascular",
    16: "Enfermedades del sistema inmunitario",
    17: "Enfermedades del sistema musculoesquelético, de los nervios o del tejido conectivo",
    18: "Enfermedades del sistema nervioso",
    19: "Enfermedades endocrinas, nutricionales o metabólicas",
    20: "Enfermedades odontológicas",
    21: "Factores que influyen en el estado de salud o el contacto con los servicios de salud",
    22: "Neoplasias",
    23: "Niño/adolescente sano",
    24: "Trastornos mentales, del comportamiento y del neurodesarrollo",
    25: "Traumatismos, intoxicaciones u otras consecuencias de causas externas de morbilidad o mortalidad",
    26: "N/A",
  };
  useEffect(() => {
    setTipoEnfermedad(
      tipoEnfermedadMap[codigoTipoEnf] ||
        (codigoTipoEnf ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoTipoEnf]);
  useEffect(() => {
    setTipoEnfermedad2(
      tipoEnfermedadMap[codigoTipoEnf2] ||
        (codigoTipoEnf2 ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoTipoEnf2]);
  useEffect(() => {
    const pesoNum = parseFloat(pesoGL);
    const tallaNum = parseFloat(tallaGL);
    if (pesoNum > 0 && tallaNum > 0) {
      const tallaMetros = tallaNum / 100;
      const imc = pesoNum / (tallaMetros * tallaMetros);
      setImcGL(imc.toFixed(2));
    } else {
      setImcGL("");
    }
  }, [pesoGL, tallaGL]);

  useEffect(() => {
    const imcNum = parseFloat(imcGL);
    const pbNum = parseFloat(pbGL);
    const numSemanas = parseInt(semanasGestacion, 10) || 0;

    let nuevoDiag = "";

    if (sexoBenef === "Mujer" && condicionMujer === "En Gestación") {
      if (numSemanas > 0 && numSemanas < 20) {
        if (pbNum > 0 && imcNum > 0) {
          if (pbNum < 21.1 && imcNum < 18.5) {
            nuevoDiag = "Bajo Peso";
          } else if (pbNum > 22.1 && imcNum >= 18.5 && imcNum <= 24.99) {
            nuevoDiag = "Peso Adecuado";
          } else {
            if (imcNum < 18.5) nuevoDiag = "Bajo Peso";
            else if (imcNum <= 24.9) nuevoDiag = "Adecuado";
            else if (imcNum <= 29.9) nuevoDiag = "Sobrepeso";
            else nuevoDiag = "Obesidad";
          }
        }
      } else if (numSemanas >= 20) {
        if (pbNum > 0) {
          if (pbNum < 21.1) {
            nuevoDiag = "Bajo Peso";
          } else if (pbNum > 22.1) {
            nuevoDiag = "Peso Adecuado";
          } else {
            nuevoDiag = "Adecuado";
          }
        }
      }
    } else if (sexoBenef === "Mujer" && condicionMujer === "En Lactancia") {
      if (pbNum > 0 && imcNum > 0) {
        if (pbNum > 22.1 && imcNum >= 18.5 && imcNum <= 24.99) {
          nuevoDiag = "Peso Adecuado";
        } else {
          if (imcNum < 18.5) nuevoDiag = "Bajo Peso";
          else if (imcNum <= 24.9) nuevoDiag = "Adecuado";
          else if (imcNum <= 29.9) nuevoDiag = "Sobrepeso";
          else nuevoDiag = "Obesidad";
        }
      }
    }

    setDiagIngresoGL(nuevoDiag);
  }, [imcGL, pbGL, semanasGestacion, sexoBenef, condicionMujer]);

  const esMenorDe5Anos = edadEnMeses !== null && edadEnMeses <= 59;

  useEffect(() => {
    if (esMenorDe5Anos) {
      if (diagFinalM5 === "Desnutrición Aguda Severa") {
        setRutfM5("Si");
        setDosisMedicamentoM5("2 sobres al día por 30 días");
        setKitHigieneM5("Si");
      } else if (diagFinalM5 === "Desnutrición Aguda Moderada") {
        setRutfM5("Si");
        setDosisMedicamentoM5("1 sobre al día por 30 días");
        setKitHigieneM5("Si");
      } else {
        if (rutfM5 === "Si") setRutfM5("No");
        if (dosisMedicamentoM5) setDosisMedicamentoM5("");
        // REGLA: Si el diagnóstico es vacío, Kit Higiene debe ser "No"
        setKitHigieneM5("No");
      }
    }
  }, [diagFinalM5, esMenorDe5Anos]);

  useEffect(() => {
    if (ejecutar) {
      const fetchAllData = async () => {
        const clienteAxios = await getAxiosClient();
        try {
          const [usersRes, patologiasRes, medsRes] = await Promise.all([
            axios.get("/usuariostranscripcion"),
            axios.get("/patologias/"),
            axios.get("/medicamentos/", {
              params: { codigoProyecto: Number(proyect.idProyecto), sector: 3 },
            }),
          ]);
          setUsuarios(
            usersRes.data.map((u) => ({
              ...u,
              nombreCompleto: `${u.nombres} ${u.apellidos}`,
            })),
          );
          setPatologias(patologiasRes.data);
          setMedicamentos(medsRes.data);
          setEstadoSalud("Zulia");
          setMunicipioSalud("Maracaibo");
          setParroquiaSalud("Olegario Villalobos");
        } catch (error) {
          console.error("Error al cargar los datos iniciales:", error);
        }
        setEjecutar(false);
      };
      fetchAllData();
    }
  }, [ejecutar, proyect]);

  useEffect(() => {
    if (fechaNacSalud) {
      const currentDate = new Date(fechaActSalud);
      const birthDate = new Date(fechaNacSalud);
      if (!isNaN(birthDate.getTime())) {
        const diffTime = currentDate - birthDate;
        const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const totalMonths = Math.floor(totalDays / 30.4375);
        const years = Math.floor(totalDays / 365.25);
        setEdadEnMeses(totalMonths);
        setEdadSalud(
          `${years} año(s) y ${Math.floor((totalDays % 365.25) / 30.4375)} mes(es)`,
        );
        if (tipoActividad === 3) {
          if (years <= 11) setRangoEdadSalud("0-11 años");
          else if (years <= 17) setRangoEdadSalud("12-17 años");
          else if (years <= 35) setRangoEdadSalud("18-35 años");
          else if (years <= 54) setRangoEdadSalud("36-54 años");
          else setRangoEdadSalud("Mayor de 55 años");
          setValueRep("N/A");
          setValueApellidoRep("N/A");
          clearError("valueRep");
          clearError("valueApellidoRep");
        } else {
          if (years <= 4) setRangoEdadSalud("0-4 años");
          else if (years <= 17) setRangoEdadSalud("5-17 años");
          else if (years <= 49) setRangoEdadSalud("18-49 años");
          else setRangoEdadSalud("50 años o más");
          if (years >= 18) {
            setValueRep("N/A");
            setValueApellidoRep("N/A");
            clearError("valueRep");
            clearError("valueApellidoRep");
          }
        }
      } else {
        setEdadSalud("");
        setRangoEdadSalud("");
        setEdadEnMeses(null);
      }
    } else {
      setEdadSalud("");
      setRangoEdadSalud("");
      setValueRep("");
      setValueApellidoRep("");
      setEdadEnMeses(null);
    }
  }, [fechaNacSalud, fechaActSalud, tipoActividad]);

  const esMujerGestanteOLactante =
    sexoBenef === "Mujer" &&
    (condicionMujer === "En Gestación" || condicionMujer === "En Lactancia");

  const mostrarDosisLactancia =
    esMujerGestanteOLactante &&
    diagIngresoGL !== "" &&
    (condicionMujer === "En Gestación" ||
      (condicionMujer === "En Lactancia" &&
        tiempoLactancia !== "" &&
        parseInt(tiempoLactancia, 10) <= 6));

  const mostrarDosisPlumpyMum =
    diagIngresoGL === "Bajo Peso" && condicionMujer === "En Gestación";

  useEffect(() => {
    if (!esMujerGestanteOLactante) {
      setPesoGL("");
      setTallaGL("");
      setPbGL("");
      setDiagIngresoGL("");
    }
  }, [esMujerGestanteOLactante]);

  useEffect(() => {
    if (fechaNacSalud === null && sexoBenef === "Mujer") {
      setCondicionMujer("");
      setSemanasGestacion("");
    }
  }, [fechaNacSalud, sexoBenef]);

  useEffect(() => {
    if (mostrarDosisLactancia) {
      setDosisCalcio("CALCIO 500 MG (CAJA X 30 CAPSULAS)");
      setDosisAcidoFolico("ÁCIDO FÓLICO 350 MG (CAJA X 30 TAB)");
      setDosisSulfatoFerroso("SULFATO FERROSO 40 MG (CAJA X 30 TAB)");
    } else {
      setDosisCalcio("N/A");
      setDosisAcidoFolico("N/A");
      setDosisSulfatoFerroso("N/A");
    }
  }, [mostrarDosisLactancia]);

  useEffect(() => {
    if (mostrarDosisPlumpyMum) {
      setDosisPlumpyMum("Plumpy'Mum (1 Sobre al día)");
    } else {
      setDosisPlumpyMum("N/A");
    }
  }, [mostrarDosisPlumpyMum]);

  useEffect(() => {
    // REGLA: No mostrar diagnóstico si el puntaje Z está vacío y no hay edema
    if (puntajezM5 === "" && edema !== "Si") {
      setDiagFinalM5("");
      return;
    }

    if (edema === "Si") {
      setDiagFinalM5("Desnutrición Aguda Severa");
    } else if (diagPbM5 > 0 && diagNutM5 > 0) {
      if (diagPbM5 < diagNutM5) {
        setDiagFinalM5(pbM5);
      } else {
        setDiagFinalM5(clasificacionNutM5);
      }
    } else if (diagPbM5 > 0) {
      setDiagFinalM5(pbM5);
    } else if (diagNutM5 > 0) {
      setDiagFinalM5(clasificacionNutM5);
    } else {
      setDiagFinalM5("");
    }
  }, [diagPbM5, diagNutM5, pbM5, clasificacionNutM5, edema, puntajezM5]);

  const validateForm = () => {
    return true;
  };
 const handleFilterId = (nombre) => {
    console.log(nombre);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      setOpenNotiError(true);
      setTimeout(() => setOpenNotiError(false), 3000);
      return;
    }
    setDisableBtnSalud(true);
    const clienteAxios = await getAxiosClient();
    const motivosConsulta = data.map((item) => item.motivoConsulta);
    const diagnosticosConsulta = data3.map((item) => item.diagnostico);
    const resultados = tratamiento.map((desc) => ({
      descripcion: desc,
      id_medicamento:
        medicamentos.find((m) => m.descripcion === desc)?.id_medicamento ||
        null,
    }));
    const cedu = valueCedula.trim() === "" ? "N/P" : valueCedula;
    const pesoNA = peso.trim() === "" ? "N/A" : peso;
    const telef =
      !tlf.textmask ||
      ["", "+", "+00(__) 000-0000"].includes(tlf.textmask.trim())
        ? "N/P"
        : tlf.textmask;
    try {
      await clienteAxios.post("/crearBeneficiarioSalud", {
        codigo_proyecto: Number(proyect.idProyecto),
        id_convocatoria: proyect.id,
        estado: estadoSalud,
        municipio: municipioSalud,
        parroquia: parroquiaSalud,
        centro: estSalud,
        comunidad: comunidadSalud,
        grupo_etnico: codigoGrupoEtnico,
        cedula: cedu,
        nombre_rep: valueRep,
        apellido_rep: valueApellidoRep,
        telefono: telef,
        codigo: codigoBeneficiario,
        nombre: valueNombre,
        apellido: valueApellido,
        sexo: sexoBenef,
        genero: valueGenero,
        lgbtqi: lgbtqi,
        nivel_educativo: codigoNivelEducativo,
        rango_edad: rangoEdadSalud,
        ingresos: ingresosPropios,
        movilidad: codigoMovilidad,
        factores_riesgo1: codigoFactoresRiesgo,
        factores_riesgo2: codigoFactoresRiesgo2,
        factores_riesgo3: codigoFactoresRiesgo3,
        cabeza_familia: cabezaFamilia,
        motivoConsulta1: motivosConsulta[0] || null,
        motivoConsulta2: motivosConsulta[1] || null,
        motivoConsulta3: motivosConsulta[2] || null,
        motivoConsulta4: motivosConsulta[3] || null,
        motivoConsulta5: motivosConsulta[4] || null,
        tratamientos: JSON.stringify(tratamiento),
        diagnosticos1: diagnosticosConsulta[0] || null,
        diagnosticos2: diagnosticosConsulta[1] || null,
        diagnosticos3: diagnosticosConsulta[2] || null,
        diagnosticos4: diagnosticosConsulta[3] || null,
        diagnosticos5: diagnosticosConsulta[4] || null,
        tipo_enfermedad1: codigoTipoEnf,
        tipo_enfermedad2: codigoTipoEnf2,
        fecha_nacimiento: fechaNacSalud,
        fecha_evaluacion: fechaActSalud,
        edad: edadSalud,
        discapacidad: codigoDisc,
        peso: pesoNA,
        comentarios: comentAdicionales,
        medico: inputValue,
        medicoId: medicoM5,
        estatus: 0,
        tipo: "Salud",
        clasificacion,
        transcrito: items.usuario,
        resultado: resultados,
        dosis_calcio: dosisCalcio,
        dosis_acido_folico: dosisAcidoFolico,
        dosis_sulfato_ferroso: dosisSulfatoFerroso,
        dosis_plumpy_mum: dosisPlumpyMum,
      });
      setOpenAlert(true);
      setTimeout(() => setOpenAlert(false), 2000);
      setValueNombre("");
      setValueApellido("");
      setSexoBenef("");
      setValueGenero("");
      setValueCedula("");
      setValueTlf({ textmask: "" });
      setFechaNacSalud(null);
      setEdadSalud("");
      setValueRep("");
      setValueApellidoRep("");
      setLgbtqi("");
      setCodigoGrupoEtnico("");
      setGrupoEtnico("");
      setCodigoDisc("");
      setDisc("");
      setCodigoMovilidad("");
      setCondicionMovilidad("");
      setCodigoFactoresRiesgo("");
      setFactoresRiesgo("");
      setCodigoFactoresRiesgo2("");
      setFactoresRiesgo2("");
      setCodigoFactoresRiesgo3("");
      setFactoresRiesgo3("");
      setCodigoNivelEducativo("");
      setNivelEducativo("");
      setCabezaFamilia("");
      setIngresosPropios("");
      setPeso("");
      setData([{ motivoConsulta: "" }]);
      setData3([{ diagnostico: "" }]);
      setCodigoTipoEnf("");
      setTipoEnfermedad("");
      setCodigoTipoEnf2("");
      setTipoEnfermedad2("");
      setTratamiento([]);
      setValueCA("");
      setErrors({});
      setInputValue("");
      setMedicoM5("");
      setValue(null);
      setCodigoBeneficiario("");
      setComunidadSalud("");
      setCondicionMujer("");
      setSemanasGestacion("");
    } catch (error) {
      setOpenNotiError(true);
      setTimeout(() => setOpenNotiError(false), 3000);
    } finally {
      setDisableBtnSalud(false);
    }
  };

  return (
    <Box m="1.5rem 2.5rem">
      {rol && ["1", "2", "6", "8", "9", "10", "11"].includes(rol) ? (
        <>
          <Collapse in={openAlert}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton size="small" onClick={() => setOpenAlert(false)}>
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Datos guardados exitosamente!
            </Alert>
          </Collapse>
          <Collapse in={openNotiError}>
            <Alert
              variant="filled"
              severity="error"
              action={
                <IconButton
                  size="small"
                  onClick={() => setOpenNotiError(false)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Error al guardar! Verifique los campos requeridos.
            </Alert>
          </Collapse>
          <Box>
            <CssBaseline />
            <Box sx={{ mb: 3 }}>
              <Breadcrumbs>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  onClick={handleLinkHome}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  onClick={handleLinkTranscripcion}
                >
                  <DriveFileRenameOutlineIcon
                    sx={{ mr: 0.5 }}
                    fontSize="inherit"
                  />
                  Transcripción
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <NoteAddOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  {tipoActividad === 3
                    ? "Nuevo Beneficiario (Salud/Telemedicina)"
                    : "Nuevo Beneficiario (Salud/Nutrición)"}
                </Typography>
              </Breadcrumbs>
              <Typography
                variant="h3"
                sx={{ mt: 3, mb: 1, fontWeight: "bold" }}
              >
                {tipoActividad === 3
                  ? "Nuevo Beneficiario (Salud/Telemedicina)"
                  : "Nuevo Beneficiario (Salud/Nutrición)"}
              </Typography>
            </Box>
            <Container>
              <Card
                sx={{
                  borderRadius: 8,
                  boxShadow: 5,
                  bgcolor: theme.palette.background.alt,
                }}
              >
                <CardContent>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 3 }}
                  >
                    <Box>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="INFO. GENERAL" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Estado"
                            value={estadoSalud}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Municipio"
                            value={municipioSalud}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Parroquia"
                            value={parroquiaSalud}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Establecimiento de Salud"
                            value={estSalud}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Atención"
                              inputFormat="DD/MM/YYYY"
                              value={fechaActSalud}
                              onChange={setFechaActSalud}
                              disabled
                              renderInput={(params) => (
                                <TextField fullWidth {...params} />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL BENEFICIARIO" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Codigo"
                            fullWidth
                            required
                            value={codigoBeneficiario}
                            onChange={(e) => {
                              setCodigoBeneficiario(
                                oracionFormato(e.target.value),
                              );
                              clearError("codigoBeneficiario");
                            }}
                            error={!!errors.codigoBeneficiario}
                            helperText={errors.codigoBeneficiario}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Nombre"
                            fullWidth
                            required
                            value={valueNombre}
                            onChange={(e) => {
                              setValueNombre(oracionFormato(e.target.value));
                              clearError("valueNombre");
                            }}
                            error={!!errors.valueNombre}
                            helperText={errors.valueNombre}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Apellido"
                            fullWidth
                            required
                            value={valueApellido}
                            onChange={(e) => {
                              setValueApellido(oracionFormato(e.target.value));
                              clearError("valueApellido");
                            }}
                            error={!!errors.valueApellido}
                            helperText={errors.valueApellido}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.sexoBenef}>
                            <InputLabel id="sexo">Sexo</InputLabel>
                            <Select
                              value={sexoBenef}
                              label="Sexo"
                              onChange={handleSexoBenef}
                            >
                              <MenuItem value={"Mujer"}>Mujer</MenuItem>
                              <MenuItem value={"Hombre"}>Hombre</MenuItem>
                            </Select>
                            {errors.sexoBenef && (
                              <FormHelperText>
                                {errors.sexoBenef}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.valueGenero}>
                            <InputLabel id="genero">Género</InputLabel>
                            <Select
                              value={valueGenero}
                              label="Género"
                              onChange={handleChangeGenero}
                            >
                              <MenuItem value={"Femenino"}>Femenino</MenuItem>
                              <MenuItem value={"Masculino"}>Masculino</MenuItem>
                              <MenuItem value={"Otro"}>Otro</MenuItem>
                            </Select>
                            {errors.valueGenero && (
                              <FormHelperText>
                                {errors.valueGenero}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="cedula"
                            fullWidth
                            id="cedula"
                            label="Cédula de Identidad"
                            value={valueCedula}
                            onChange={(e) =>
                              setValueCedula(
                                e.target.value
                                  .replace(/[^\d]/g, "")
                                  .slice(0, 10),
                              )
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="telefono">Teléfono</InputLabel>
                            <OutlinedInput
                              value={tlf.textmask}
                              onChange={handleTlf}
                              name="textmask"
                              id="telefono"
                              inputComponent={TextMaskCustom}
                              label="Teléfono"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Nacimiento"
                              inputFormat="DD/MM/YYYY"
                              value={fechaNacSalud}
                              onChange={(v) => {
                                setFechaNacSalud(v);
                                clearError("fechaNacSalud");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={!!errors.fechaNacSalud}
                                  helperText={errors.fechaNacSalud}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={tipoActividad === 3 ? 2 : 4}>
                          <TextField
                            label="Edad"
                            fullWidth
                            required
                            disabled
                            value={edadSalud}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2} hidden={tipoActividad !== 3}>
                          <TextField
                            label="Grupo Etario"
                            fullWidth
                            required
                            disabled
                            value={rangoEdadSalud}
                          />
                        </Grid>
                        {sexoBenef === "Mujer" && (
                          <>
                            <Grid item xs={12} sm={4}>
                              <FormControl fullWidth>
                                <InputLabel id="condicion-mujer-label">
                                  Condición
                                </InputLabel>
                                <Select
                                  labelId="condicion-mujer-label"
                                  value={condicionMujer}
                                  label="Condición"
                                  onChange={handleCondicionMujer}
                                >
                                  <MenuItem value={"En Gestación"}>
                                    En Gestación
                                  </MenuItem>
                                  <MenuItem value={"En Lactancia"}>
                                    En Lactancia
                                  </MenuItem>
                                  <MenuItem value={"No Aplica"}>
                                    No Aplica
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            {condicionMujer === "En Gestación" && (
                              <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                  <InputLabel id="semanas-gestacion-label">
                                    Semanas de Gestación
                                  </InputLabel>
                                  <Select
                                    labelId="semanas-gestacion-label"
                                    value={semanasGestacion}
                                    label="Semanas de Gestación"
                                    onChange={handleSemanasGestacion}
                                  >
                                    <MenuItem value="">
                                      <em>Seleccionar...</em>
                                    </MenuItem>
                                    {semanasGestacionOptions.map((s) => (
                                      <MenuItem key={s} value={s}>
                                        {s}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                            )}
                            {condicionMujer === "En Lactancia" && (
                              <Grid item xs={12} sm={4}>
                                <TextField
                                  label="Tiempo de Lactancia (Meses)"
                                  type="number"
                                  fullWidth
                                  value={tiempoLactancia}
                                  onChange={handleTiempoLactancia}
                                  inputProps={{ maxLength: 2 }}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL REPRESENTANTE" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="representante"
                            fullWidth
                            label="Primer Nombre"
                            disabled={!edadEnMeses || edadEnMeses >= 216}
                            value={valueRep}
                            onChange={(e) => {
                              setValueRep(oracionFormato(e.target.value));
                              clearError("valueRep");
                            }}
                            error={!!errors.valueRep}
                            helperText={errors.valueRep}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Primer Apellido"
                            value={valueApellidoRep}
                            disabled={!edadEnMeses || edadEnMeses >= 216}
                            onChange={(e) => {
                              setValueApellidoRep(
                                oracionFormato(e.target.value),
                              );
                              clearError("valueApellidoRep");
                            }}
                            error={!!errors.valueApellidoRep}
                            helperText={errors.valueApellidoRep}
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip
                          label="DATOS DEMOGRÁFICOS DEL BENEFICIARIO"
                          sx={{
                            "&.MuiChip-root": {
                              fontSize: isSmallScreen ? "9px" : "auto",
                            },
                          }}
                        />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.lgbtqi}>
                            <InputLabel id="lgbtqi">LGBTQI+</InputLabel>
                            <Select
                              value={lgbtqi}
                              label="LGBTQI+"
                              onChange={handleLgbtqi}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.lgbtqi && (
                              <FormHelperText>{errors.lgbtqi}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Comunidad"
                            value={comunidadSalud}
                            onChange={(e) => {
                              setComunidadSalud(oracionFormato(e.target.value));
                              clearError("comunidadSalud");
                            }}
                            error={!!errors.comunidadSalud}
                            helperText={errors.comunidadSalud}
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            error={!!errors.codigoGrupoEtnico}
                            label="Código"
                            type="number"
                            value={codigoGrupoEtnico}
                            onChange={handleCodigoGrupoEtnico}
                            helperText={errors.codigoGrupoEtnico}
                            inputProps={{ min: 1, max: 7, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={grupoEtnico === "VERIFICAR CÓDIGO"}
                            label="Grupo Etnico"
                            value={grupoEtnico}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoDisc}
                            label="Código"
                            value={codigoDisc}
                            onChange={handleCodigoDisc}
                            helperText={errors.codigoDisc}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={valueDisc === "VERIFICAR CÓDIGO"}
                            label="Discapacidad"
                            value={valueDisc}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoMovilidad}
                            label="Código"
                            value={codigoMovilidad}
                            onChange={handleCodigoMovilidad}
                            helperText={errors.codigoMovilidad}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={condicionMovilidad === "VERIFICAR CÓDIGO"}
                            label="Condición de Movilidad"
                            value={condicionMovilidad}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo}
                            label="Código"
                            value={codigoFactoresRiesgo}
                            onChange={handleCodigoFactoresRiesgo}
                            helperText={errors.codigoFactoresRiesgo}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 1"
                            value={factoresRiesgo}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo2}
                            label="Código"
                            value={codigoFactoresRiesgo2}
                            onChange={handleCodigoFactoresRiesgo2}
                            helperText={errors.codigoFactoresRiesgo2}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo2 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 2"
                            value={factoresRiesgo2}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo3}
                            label="Código"
                            value={codigoFactoresRiesgo3}
                            onChange={handleCodigoFactoresRiesgo3}
                            helperText={errors.codigoFactoresRiesgo3}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo3 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 3"
                            value={factoresRiesgo3}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoNivelEducativo}
                            label="Código"
                            value={codigoNivelEducativo}
                            onChange={handleCodigoNivelEducativo}
                            helperText={errors.codigoNivelEducativo}
                            inputProps={{ min: 1, max: 6, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={nivelEducativo === "VERIFICAR CÓDIGO"}
                            label="Nivel Educativo"
                            value={nivelEducativo}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.cabezaFamilia}>
                            <InputLabel id="cabezaFamilia">
                              Cabeza de Familia
                            </InputLabel>
                            <Select
                              value={cabezaFamilia}
                              label="Cabeza de Familia"
                              onChange={handleCabezaFamilia}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.cabezaFamilia && (
                              <FormHelperText>
                                {errors.cabezaFamilia}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            error={!!errors.ingresosPropios}
                          >
                            <InputLabel id="ingresosPropios">
                              Ingresos Propios
                            </InputLabel>
                            <Select
                              value={ingresosPropios}
                              label="Ingresos Propios"
                              onChange={handleIngresosPropios}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.ingresosPropios && (
                              <FormHelperText>
                                {errors.ingresosPropios}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 2 }}>
                        <Chip label="DATOS DE CONSULTA Y MANEJO" />
                      </Divider>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            {data.map((val, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={data.length === 1 ? 12 : 9}
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      label="Motivo de Consulta"
                                      name="motivoConsulta"
                                      value={val.motivoConsulta}
                                      onChange={(e) => handleChangeInput(e, i)}
                                      error={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                      }
                                      helperText={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  {data.length > 1 && (
                                    <Grid item xs={2} sm={1}>
                                      <Tooltip title="Eliminar">
                                        <IconButton
                                          size="large"
                                          color="error"
                                          onClick={() => handleDelete(i)}
                                        >
                                          <DeleteIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  )}
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid item xs={12} sm={3} sx={{ mt: 3 }}>
                                <Button
                                  variant="contained"
                                  disabled={activar}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  fullWidth
                                  onClick={handleClick}
                                  hidden={data.length === 5}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            {data3.map((val3, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={data3.length === 1 ? 12 : 9}
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      label="Diagnóstico"
                                      name="diagnostico"
                                      value={val3.diagnostico}
                                      onChange={(e) => handleChangeInput3(e, i)}
                                      error={
                                        !!errors.diagnostico &&
                                        !val3.diagnostico.trim()
                                      }
                                      helperText={
                                        !!errors.diagnostico &&
                                        !val3.diagnostico.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  {data3.length > 1 && (
                                    <Grid item xs={2} sm={1}>
                                      <Tooltip title="Eliminar">
                                        <IconButton
                                          size="large"
                                          color="error"
                                          onClick={() => handleDelete3(i)}
                                        >
                                          <DeleteIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  )}
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid
                                item
                                xs={isSmallScreen ? 12 : 8}
                                sm={3}
                                sx={{ mt: 3 }}
                              >
                                <Button
                                  variant="contained"
                                  disabled={activar3}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  hidden={data3.length === 5}
                                  fullWidth
                                  onClick={handleClick3}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                        </Box>
                      </div>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid container mt={2} spacing={1}>
                                <Grid item xs={3} sm={3}>
                                  <TextField
                                    required
                                    fullWidth
                                    type="number"
                                    error={!!errors.codigoTipoEnf}
                                    label="Código"
                                    value={codigoTipoEnf}
                                    onChange={handleCodigoTipoEnf}
                                    helperText={errors.codigoTipoEnf}
                                    inputProps={{ min: 1, max: 26, step: 1 }}
                                  />
                                </Grid>
                                <Grid item xs={9} sm={9}>
                                  <TextField
                                    fullWidth
                                    error={
                                      tipoEnfermedad === "VERIFICAR CÓDIGO"
                                    }
                                    label="Tipo de Enfermedad 1"
                                    value={tipoEnfermedad}
                                    disabled
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid container mt={2} spacing={1}>
                                <Grid item xs={3} sm={3}>
                                  <TextField
                                    required
                                    fullWidth
                                    type="number"
                                    error={!!errors.codigoTipoEnf2}
                                    label="Código"
                                    value={codigoTipoEnf2}
                                    onChange={handleCodigoTipoEnf2}
                                    helperText={errors.codigoTipoEnf2}
                                    inputProps={{ min: 1, max: 26, step: 1 }}
                                  />
                                </Grid>
                                <Grid item xs={9} sm={9}>
                                  <TextField
                                    fullWidth
                                    error={
                                      tipoEnfermedad2 === "VERIFICAR CÓDIGO"
                                    }
                                    label="Tipo de Enfermedad 2"
                                    value={tipoEnfermedad2}
                                    disabled
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid
                                container
                                spacing={2}
                                sx={{ mt: !isSmallScreen ? 1 : 0 }}
                              >
                                <Grid item xs={12} sm={10}>
                                  <Autocomplete
                                    multiple
                                    fullWidth
                                    name="tratamiento"
                                    value={tratamiento}
                                    onChange={(e, nv) => {
                                      setTratamiento(nv);
                                      if (nv.length > 0)
                                        clearError("tratamiento");
                                    }}
                                    inputValue={inputTratamiento}
                                    onInputChange={(e, niv) =>
                                      setInputTratamiento(niv)
                                    }
                                    options={medicamentos.map(
                                      (o) => o.descripcion,
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Tratamiento"
                                        fullWidth
                                        error={!!errors.tratamiento}
                                        helperText={errors.tratamiento}
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                        </Box>
                      </div>

                      {esMenorDe5Anos && (
                        <>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="INFO. NUTRICIONAL (0-59 MESES)" />
                          </Divider>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} sm={2}>
                              <FormControl>
                                <FormLabel>Edema</FormLabel>
                                <RadioGroup
                                  row
                                  value={edema}
                                  onChange={handleChangeEdema}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Circ. de Brazo (CMB)"
                                fullWidth
                                value={cmbM5}
                                onChange={handleCmbM5}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Clasificación PB"
                                fullWidth
                                value={pbM5}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Peso (Kg)"
                                fullWidth
                                required
                                value={pesoM5}
                                onChange={(e) => setPesoM5(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Talla (cm)"
                                fullWidth
                                required
                                value={tallaM5}
                                onChange={(e) => setTallaM5(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Puntaje Z"
                                fullWidth
                                value={puntajezM5}
                                onChange={handlePuntajeZ}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                label="Clasificación Nutricional"
                                fullWidth
                                value={clasificacionNutM5}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                label="Diagnóstico de Ingreso"
                                fullWidth
                                value={diagFinalM5}
                                disabled
                              />
                            </Grid>
                          </Grid>
                          <Divider sx={{ mt: 4 }}>
                            <Chip label="TRATAMIENTO" />
                          </Divider>
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            sx={{ mt: 1 }}
                          >
                            <Grid item xs={12} sm={3} mt={3}>
                              <FormControl>
                                <FormLabel>Referido</FormLabel>
                                <RadioGroup
                                  row
                                  value={referidoM5}
                                  onChange={handleReferidoM5}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3} mt={3}>
                              <FormControl>
                                <FormLabel>RUTF (Sobre Rojo)</FormLabel>
                                <RadioGroup
                                  row
                                  value={
                                    micronutM5 === "Si" || lnsmq === "Si"
                                      ? "No"
                                      : rutfM5
                                  }
                                  onChange={handleChangeRutfM5}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                    disabled={
                                      micronutM5 === "Si" ||
                                      lnsmq === "Si" ||
                                      referidoM5 === "Si"
                                    }
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                    disabled={
                                      micronutM5 === "Si" ||
                                      lnsmq === "Si" ||
                                      referidoM5 === "Si"
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3} mt={3}>
                              <FormControl>
                                <FormLabel>Kit de Higiene</FormLabel>
                                <RadioGroup
                                  row
                                  value={kitHigieneM5}
                                  onChange={handleKitHigieneM5}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                          </Grid>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="DOSIS" />
                          </Divider>
                          <Typography
                            variant="h5"
                            align="center"
                            mt={4}
                            hidden={
                              (albendazolM5 === "Si" ||
                                micronutM5 === "Si" ||
                                lnsmq === "Si" ||
                                rutfM5 === "Si") &&
                              diagFinalM5 !== ""
                            }
                            sx={{ color: "gray" }}
                          >
                            <InfoOutlinedIcon sx={{ color: "gray" }} /> No se
                            asignaron tratamientos al beneficiario.
                          </Typography>
                          <Grid
                            container
                            spacing={2}
                            sx={{ mt: 1 }}
                            justifyContent="center"
                            hidden={rutfM5 !== "Si" || diagFinalM5 === ""}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={
                                diagFinalM5 === "Desnutrición Aguda Severa"
                                  ? 4
                                  : 6
                              }
                            >
                              <TextField
                                fullWidth
                                label="RUTF (Sobre Rojo)"
                                value={dosisMedicamentoM5}
                                disabled
                              />
                            </Grid>
                            {diagFinalM5 === "Desnutrición Aguda Severa" && (
                              <>
                                <Grid item xs={12} sm={4}>
                                  <TextField
                                    fullWidth
                                    label="Insumo Adicional 1"
                                    value="1 Ecofiltro"
                                    disabled
                                  />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                  <TextField
                                    fullWidth
                                    label="Insumo Adicional 2"
                                    value="8 Jabones de Tocador"
                                    disabled
                                  />
                                </Grid>
                              </>
                            )}
                            {diagFinalM5 === "Desnutrición Aguda Moderada" && (
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  fullWidth
                                  label="Insumo Adicional"
                                  value="8 Jabones de Tocador"
                                  disabled
                                />
                              </Grid>
                            )}
                          </Grid>
                        </>
                      )}

                      {esMujerGestanteOLactante && (
                        <>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="INFO. NUTRICIONAL (GESTANTE/LACTANTE)" />
                          </Divider>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Peso (Kg)"
                                fullWidth
                                required
                                value={pesoGL}
                                onChange={(e) => setPesoGL(e.target.value)}
                                type="number"
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Talla (cm)"
                                fullWidth
                                required
                                value={tallaGL}
                                onChange={(e) => setTallaGL(e.target.value)}
                                type="number"
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="PB"
                                fullWidth
                                required
                                value={pbGL}
                                onChange={handlePbGL}
                                type="number"
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="IMC"
                                fullWidth
                                value={imcGL}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Diagnóstico de Ingreso"
                                fullWidth
                                value={diagIngresoGL}
                                disabled
                              />
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {mostrarDosisLactancia && (
                        <>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="DOSIS (GESTACIÓN/LACTANCIA)" />
                          </Divider>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid
                              item
                              xs={12}
                              sm={mostrarDosisPlumpyMum ? 6 : 4}
                            >
                              <TextField
                                label="Dosis 1"
                                fullWidth
                                disabled
                                value={dosisCalcio}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={mostrarDosisPlumpyMum ? 6 : 4}
                            >
                              <TextField
                                label="Dosis 2"
                                fullWidth
                                disabled
                                value={dosisAcidoFolico}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={mostrarDosisPlumpyMum ? 6 : 4}
                            >
                              <TextField
                                label="Dosis 3"
                                fullWidth
                                disabled
                                value={dosisSulfatoFerroso}
                              />
                            </Grid>
                            {mostrarDosisPlumpyMum && (
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  label="Dosis 4"
                                  fullWidth
                                  disabled
                                  value={dosisPlumpyMum}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </>
                      )}

                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="ADICIONALES" />
                      </Divider>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                             value={value}
                                                            onChange={(event, newValue) => {
                                                              setMedicoM5(newValue.id);
                                                            }}
                                                            inputValue={inputValue}
                                                            onInputChange={(event, newInputValue) => {
                                                              setInputValue(newInputValue);
                                                              handleFilterId(newInputValue);
                                                            }}
                                                            disablePortal
                                                            id="combo-box-demo"
                                                            options={usuarios}
                                                            getOptionLabel={(usuarios) =>
                                                              usuarios.nombreCompleto
                                                            }
                                                            sx={{ width: "100%" }}
                                                            renderInput={(params) => (
                                                              <TextField
                                                                {...params}
                                                                label="Médico Tratante"
                                                              />
                                                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Comentarios"
                            value={comentAdicionales}
                            fullWidth
                            multiline
                            maxRows={4}
                            onChange={(e) =>
                              setValueCA(oracionFormato(e.target.value))
                            }
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 5 }} />
                      <Grid
                        container
                        sx={{ mt: 2 }}
                        spacing={1}
                        justifyContent="center"
                      >
                        <Grid item sm={3} xs={6}>
                          <Button
                            variant="contained"
                            color="error"
                            size="large"
                            fullWidth
                            onClick={handleOpen}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item sm={3} xs={6}>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            size="large"
                            fullWidth
                            disabled={disableBtnSalud}
                          >
                            Guardar
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              <Modal
                open={open}
                onClose={handleClose}
                slotProps={{ backdrop: { style: { opacity: 0.2 } } }}
              >
                <Box sx={style}>
                  <Typography variant="h6" align="center" sx={{ mb: 1.5 }}>
                    ¿Está seguro de cancelar esta operación?
                  </Typography>
                  <Divider sx={{ mt: 2 }} />
                  <Grid
                    container
                    sx={{ mt: 1 }}
                    spacing={1}
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        No
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        onClick={handleLinkCancelar}
                      >
                        Si
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </Container>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default NutriSaludForm;
